// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD_LiHEwopK-JVuW2GLNOJIa2Vgm6G2j1Y',
    authDomain: 'ibd-demo.firebaseapp.com',
    databaseURL: 'https://ibd-demo.firebaseio.com',
    projectId: 'ibd-demo',
    storageBucket: 'ibd-demo.appspot.com',
    messagingSenderId: '265177545799'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts